import logo from "@/assets/logo.png";

export const AppLogo = () => {
  return (
    <div className="flex w-full items-center gap-2 overflow-clip text-sm font-bold">
      <img src={logo} className="h-7.5 w-7.5" />
      <span className="truncate">Glitch Hunt</span>
    </div>
  );
};
